import React, { ComponentType, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Menu } from 'antd';
import { History } from 'history';
import { useOnClickOutside } from 'utils/hooks';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'constant';
import { logOut } from 'modules/Auth/Auth.actions';
import { IMenuList } from 'interfaces';
import { RenderMenuList } from 'components/MenuList';
import { getPermissions } from 'utils/helpers';

interface IProfileMenu extends RouteComponentProps<any> {
  history: History;
  avatar?: JSX.Element;
}

export const ProfileMenu = withRouter<IProfileMenu, ComponentType<IProfileMenu>>(
  ({ avatar, history }: IProfileMenu) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const permission = getPermissions();
    const [state, setState] = useState(false);
    const handleDropdown = () => {
      setState(!state);
    };
    const closeDropdown = () => {
      setState(false);
    };
    const dropdownRef = useRef(null);
    useOnClickOutside(dropdownRef, () => setState(false));

    const handleLogout = () => {
      dispatch(logOut.request());
      history.push(ROUTES.AUTH.LOGIN_PAGE);
    };

    const MenuList: IMenuList[] = [
      {
        key: 'AGENT_ACCOUNT_SETTINGS_PAGE',
        onClick: closeDropdown,
        exact: true,
        to: ROUTES.PROFILE.AGENT_ACCOUNT_SETTINGS_PAGE,
        title: t('Account Settings'),
      },
      {
        key: 'INVOICES',
        onClick: closeDropdown,
        to: `${ROUTES.PROFILE.AGENT_ACCOUNT_SETTINGS_PAGE}${ROUTES.PROFILE.INVOICES}${
          permission?.user ? ROUTES.PROFILE.PLANS : ''
        }`,
        title: permission?.user ? t('My subscription') : t('Invoices'),
        permissions: ['super admin', 'user'],
      },
      {
        key: 'GENERAL_STATS',
        onClick: closeDropdown,
        to: `${ROUTES.PROFILE.AGENT_ACCOUNT_SETTINGS_PAGE}${ROUTES.ADMIN_PANEL.GENERAL_STATISTICS}`,
        title: t('Statistics'),
        permissions: ['super admin'],
      },
      {
        key: 'USERS_ADMIN_PANEL',
        onClick: closeDropdown,
        exact: true,
        to: `${ROUTES.PROFILE.AGENT_ACCOUNT_SETTINGS_PAGE}${ROUTES.ADMIN_PANEL.USERS_ADMIN_PANEL}`,
        title: t('Users'),
        permissions: ['super admin', 'redactor'],
      },
      {
        key: 'REDACTOR_PAGE',
        onClick: closeDropdown,
        exact: true,
        to: `${ROUTES.PROFILE.AGENT_ACCOUNT_SETTINGS_PAGE}${ROUTES.ADMIN_PANEL.REDACTOR_PAGE}`,
        title: t('Events'),
        permissions: ['super admin', 'redactor', 'producer'],
      },
      {
        key: 'USERS_EVENTS',
        onClick: closeDropdown,
        to: `${ROUTES.PROFILE.AGENT_ACCOUNT_SETTINGS_PAGE}${ROUTES.PROFILE.USERS_EVENTS}`,
        title: t('My events'),
        permissions: ['user'],
      },
      {
        key: 'FAVORITES',
        onClick: closeDropdown,
        to: `${ROUTES.PROFILE.AGENT_ACCOUNT_SETTINGS_PAGE}${ROUTES.PROFILE.FAVORITES}`,
        title: t('My favorites'),
        permissions: ['user'],
      },
      {
        key: 'TAGS',
        onClick: closeDropdown,
        exact: true,
        to: `${ROUTES.PROFILE.AGENT_ACCOUNT_SETTINGS_PAGE}${ROUTES.ADMIN_PANEL.TAGS}`,
        title: t('Tags'),
        permissions: ['super admin'],
      },
      {
        key: 'PHONETICS',
        onClick: closeDropdown,
        exact: true,
        to: `${ROUTES.PROFILE.AGENT_ACCOUNT_SETTINGS_PAGE}${ROUTES.ADMIN_PANEL.PHONETICS}`,
        title: t('Phonetics'),
        permissions: ['super admin', 'redactor'],
      },
      {
        key: 'COMMENTS_PAGE',
        onClick: closeDropdown,
        exact: true,
        to: `${ROUTES.PROFILE.AGENT_ACCOUNT_SETTINGS_PAGE}${ROUTES.ADMIN_PANEL.COMMENTS_PAGE}`,
        title: t('Comments'),
        permissions: ['super admin', 'redactor'],
      },
    ];

    return (
      <div className="avatar-dropdown" ref={dropdownRef}>
        <div className="dropdown-handler" onClick={handleDropdown}>
          {avatar}
        </div>

        <Menu className={`dropdown-menu ${state ? 'active' : 'hide'}`}>
          {RenderMenuList(MenuList)}
          <Menu.Item key="5">
            <button onClick={handleLogout}>{t('Log Out')}</button>
          </Menu.Item>
        </Menu>
      </div>
    );
  },
);
